function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { VscLoading } from "react-icons/vsc";
import "./Loader.css";
var Loader = /*#__PURE__*/React.memo(function (_ref) {
  var wrapperProps = _ref.wrapperProps,
    iconProps = _ref.iconProps;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: "loading-wrapper"
  }, wrapperProps), /*#__PURE__*/React.createElement(VscLoading, _extends({
    className: "loading-svg"
  }, iconProps)));
});
export default Loader;